import React from "react";

const Footer = () => {
    return (
     <div className="footer">
        <div>Copyright &copy; 2022</div>
        <div className="home_about">Home</div>
        <div className="home_about">About</div>
      </div>
    )
}

export default Footer;
